import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { TipPlacement, Tooltip } from 'ui/tooltip';

const IconWrapper = styled.div<{ $isSelected: boolean }>`
  svg {
    height: ${({ theme }) => theme.spacing.values.base};

    path {
      stroke: none !important;
      fill: none !important;

      &[fill] {
        fill: ${({ theme, $isSelected }) =>
          $isSelected
            ? theme.colors.primaryColors.purple50
            : theme.colors.textColors.textSecondary} !important;
      }

      &[stroke] {
        stroke: ${({ theme, $isSelected }) =>
          $isSelected
            ? theme.colors.primaryColors.purple50
            : theme.colors.textColors.textSecondary} !important;
      }
    }
  }
`;

const Button = styled(IconButton)`
  border-radius: 50%;
  &::before {
    border-radius: 50%;
  }
`;

type BaseToolbarButtonProps = {
  onClick: () => void;
  tooltip: string;
  isSelected: boolean;
  tooltipPlacement?: TipPlacement;
  'data-test'?: string;
};

export const BaseToolbarButton: FC<PropsWithChildren<BaseToolbarButtonProps>> = ({
  onClick,
  children,
  tooltip,
  isSelected,
  tooltipPlacement,
  'data-test': dataTest,
}) => {
  return (
    <Tooltip tooltipContent={tooltip} placement={tooltipPlacement} disableHoverableContent>
      <Button variant={BUTTON_VARIANTS.GHOST} onClick={onClick} data-test={dataTest}>
        <IconWrapper $isSelected={isSelected}>{children}</IconWrapper>
      </Button>
    </Tooltip>
  );
};
